import { render, staticRenderFns } from "./LinkFrame.vue?vue&type=template&id=1146c11a&scoped=true&"
import script from "./LinkFrame.vue?vue&type=script&lang=js&"
export * from "./LinkFrame.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=1146c11a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146c11a",
  null
  
)

export default component.exports